import React from 'react';

export interface ExternalLinkProps
  extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
}

const isPlainLeftClick = (event: React.MouseEvent<HTMLAnchorElement>) =>
  event.button === 0 &&
  !event.metaKey &&
  !event.ctrlKey &&
  !event.shiftKey &&
  !event.altKey;

export const ExternalLink: React.FC<ExternalLinkProps> = ({
  href,
  target = '_blank',
  rel = 'noopener noreferrer',
  onClick,
  children,
  ...props
}) => {
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    const wasDefaultPrevented = event.defaultPrevented;

    onClick?.(event);

    if (
      !wasDefaultPrevented ||
      target !== '_blank' ||
      !isPlainLeftClick(event)
    ) {
      return;
    }

    window.open(event.currentTarget.href, target, 'noopener,noreferrer');
  };

  return (
    <a href={href} target={target} rel={rel} onClick={handleClick} {...props}>
      {children}
    </a>
  );
};
